import {
  Button,
  cn,
  TokenIcon,
  type TokenIconSymbol,
  tokenIconSymbols,
  Typography,
} from "@kyan/ui";
import Link from "next/link";

import { ConnectWalletWrapper } from "#/components/ConnectWalletWrapper/ConnectWalletWrapper";
import { routes } from "#/config/routes";
import { type UnderlyingSymbol } from "#/types/markets";

interface EmptyStateProps {
  className?: string;
  description?: string;
  underlying?: UnderlyingSymbol;
  shouldShowAction?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  className,
  description,
  underlying,
  shouldShowAction,
}) => {
  return (
    <div
      className={cn(
        "flex h-full min-h-40 flex-col items-center justify-center gap-3 py-4",
        className,
      )}
    >
      <div className="flex items-center justify-center gap-4">
        {(underlying
          ? [underlying.toLowerCase() as TokenIconSymbol]
          : tokenIconSymbols.filter((t) => t !== "usdc")
        ).map((token) => (
          <TokenIcon gradient key={token} symbol={token} />
        ))}
      </div>
      <Typography primary>{description}</Typography>
      {shouldShowAction && (
        <ConnectWalletWrapper size="sm" className="mt-0 w-32 text-[13px]">
          <Link href={routes.options()}>
            <Button size="sm" className="w-20">
              Trade
            </Button>
          </Link>
        </ConnectWalletWrapper>
      )}
    </div>
  );
};
